import { BoxCollider } from "../Physics/BoxCollider";
import { CompoundBoxCollider } from "../Physics/CompoundBoxCollider";
import { IPhysicsBody } from "../Physics/IPhysicsBody";

export class DebugPhysicsRenderer extends PIXI.Container {
    private _graphics: PIXI.Graphics;
    private _root: PIXI.TransformBase | undefined;
    private _tempBox: BoxCollider;

    constructor() {
        super();

        this._tempBox = new BoxCollider();

        this._graphics = new PIXI.Graphics();
        this.addChild(this._graphics);
    }

    public render(pRoot: PIXI.Container): void {
        this._root = pRoot.transform;
        this._graphics.clear();
        this._graphics.beginFill(0xFF0000, 0.4);
        this.renderNode(pRoot);
        this._graphics.endFill();
        this._root = undefined;
    }

    private renderNode(pNode: PIXI.DisplayObject): void {
        if (this.isPhysicsBody(pNode) && pNode.active) {
            this.renderBody(pNode);
        }

        if (!(pNode instanceof PIXI.Container) || pNode.children.length === 0) {
            return;
        }

        else {
            for (let i = pNode.children.length - 1; i >= 0; --i) {
                this.renderNode(pNode.children[i]);
            }
        }
    }

    private renderBody(pBody: IPhysicsBody): void {
        const pos: PIXI.Point = this._root!.worldTransform.applyInverse(pBody.getGlobalPosition());
        if (pBody.collider instanceof BoxCollider) {
            this.renderBox(this._tempBox.copy(pBody.collider).offset(pos));
        }
        else if (pBody.collider instanceof CompoundBoxCollider) {
            for (let i = 0; i < pBody.collider.boxes.length; ++i) {
                this.renderBox(this._tempBox.copy(pBody.collider.boxes[i]).offset(pos));
            }
        }
    }

    private renderBox(pBox: BoxCollider): void {
        this._graphics.drawRect(
            pBox.left,
            pBox.top,
            pBox.right - pBox.left,
            pBox.bottom - pBox.top,
        );
    }

    private isPhysicsBody(pObj: any): pObj is IPhysicsBody {
        return pObj && pObj.collider;
    }
}
